// Sending a signature with this device's proof (#24 phase 3). A device holds one live proof challenge, and asking for a
// new one (another tab, another card) replaces the last, so a proof can be refused as invalid through no fault of this
// device. Such a refusal is answered once more with a proof from a fresh challenge. The signed transaction itself is sent
// again as it was: the proof is separate from it, so nothing is signed with the ledger key twice.
import { lambdaErrorCode } from './lambda.js';
import { DEVICE_PROOF_INVALID_CODE } from './public-ledger-copy.js';

/**
 * Sends with a fresh device proof and, when the server refuses that proof as invalid (DEVICE_PROOF_INVALID), makes a new
 * one and sends once more. A second refusal, or any other error, is thrown as it came.
 * @param prove asks for a challenge and signs it with the device key
 * @param send sends the signature with the proof
 */
export async function sendWithDeviceProof<P, T>(prove: () => Promise<P>, send: (proof: P) => Promise<T>): Promise<T> {
  try {
    return await send(await prove());
  } catch (err) {
    if (lambdaErrorCode(err) !== DEVICE_PROOF_INVALID_CODE) throw err;
  }
  return await send(await prove());
}
